import React from 'react'
import { Helmet } from 'react-helmet'
import { Overwrite } from 'utility-types'

const defaults = {
  title: 'Prisma Blog | Articles & Updates | Prisma, ORMs, Databases',
  description:
    'Stay up to date with the latest from Prisma. Guides, announcements, and articles about Prisma, ORMs, databases, and the data access layer.',
  image: 'https://prisma.io/blog/blog/og-image.png',
  video: 'https://www.youtube.com/watch?v=jF9VULLzwVk',
  url: 'https://www.prisma.io/blog',
  type: 'website'
}

type NullableVideo = { video: null | string }
type SocialMetaProps = Partial<Overwrite<typeof defaults, NullableVideo>>

const SocialMeta = (props: SocialMetaProps) => {
  const { title, description, image, video, url, type } = { ...defaults, ...props }
  const urlWithoutSlash = url.replace(/\/$/, "")

  return (
    <Helmet>
      {description && <meta name="description" content={description} />}
      {image && <meta name="image" content={image} />}
      {title && <meta itemProp="name" content={title} />}
      {description && <meta itemProp="description" content={description} />}
      {image && <meta itemProp="image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:site" content="@prisma" />
      <meta name="twitter:creator" content="@prisma" />
      {image && <meta name="twitter:image:src" content={image} />}
      {video && <meta name="twitter:player" content={video} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
      <meta property="og:url" content={urlWithoutSlash} />
      <meta property="og:site_name" content="Prisma" />
      {video && <meta property="og:video" content={video} />}
      <meta property="og:type" content={type} />
      <link rel="canonical" href={urlWithoutSlash}/>
    </Helmet>
  )
}

export default SocialMeta
